import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setProgress, setToast } from "../../redux/slice/system";
import { setFormStep, setFormType, setFormUser } from "../../redux/slice/form";
import { useHookForm, useCaptcha } from "../../components/hooks";
import { MainAPI } from "../../axios/api";

import { ModuleSubHead } from "../../components/other";
import {
  FormCalendar,
  FormInputtext,
  FormRadio,
  FormInputnumber,
} from "../../components/formElement/index";
import {
  option_parent,
  option_sex,
  option_education,
  option_want,
} from "../../service/option";
import { system_email } from "../../service/system";
import moment from "moment";

import ImgEnvelope from "../../images/icon/icn_envelope.PNG";
import ImgGender from "../../images/icon/icn_gender.PNG";
import ImgBirthday from "../../images/icon/icn_birthday.PNG";
import ImgHat from "../../images/icon/icn_hat.PNG";
import ImgEye from "../../images/icon/icn_eye.PNG";
import ImgClock from "../../images/icon/icn_clock.PNG";
import ImgGlasses from "../../images/icon/icn_glasses.PNG";
import ImgPen from "../../images/icon/icn_pen.PNG";
import ImgCode from "../../images/icon/icn_code.PNG";

import { Button } from "primereact/button";
import { classNames } from "primereact/utils";

export default function FrontBasicForm(props) {
  const route_navigate = useNavigate();
  const dispatch = useDispatch();
  const redux_form = useSelector((state) => state.form);
  const { captchaSetting, renderCaptcha } = useCaptcha();
  // 表單欄位預設值
  const defaultValues = {
    email: "",
    psex: null,
    edlevel: null,
    ksex: null,
    birthday: null,
    ldegree: null,
    rdegree: null,
    lastigmatism: null,
    rastigmatism: null,
    tyear: null,
    tmonth: null,
    treatment: "",
    laxis: "",
    raxis: "",
    isagree: null,
    address: "",
    code: "",
  };
  const { handleSubmit, getValues, setValue, yup, setSchema, errors, setting } =
    useHookForm({
      defaultValues,
    });

  useEffect(() => {
    setSchema(
      yup
        .object({
          email: yup
            .string()
            .matches(system_email.valid, {
              message: "電子郵件格式錯誤(ex:abc@gmail.com)",
              excludeEmptyString: true,
            })
            .required("必填"),
          psex: yup.number().required("必填").nullable(),
          edlevel: yup.number().required("必填").nullable(),
          ksex: yup.number().required("必填").nullable(),
          birthday: yup.string().required("必填").nullable(),
          ldegree: yup.number().required("必填").nullable(),
          rdegree: yup.number().required("必填").nullable(),
          lastigmatism: yup.number().required("必填").nullable(),
          rastigmatism: yup.number().required("必填").nullable(),
          tyear: yup.number().required("必填").nullable(),
          tmonth: yup.number().required("必填").nullable(),
          treatment: yup.string().required("必填"),
          laxis: yup.string().required("必填"),
          raxis: yup.string().required("必填"),
          isagree: yup.number().required("必填").nullable(),
          address: yup
            .string()
            .test(
              "isValidPass",
              "必填",
              (value, { from: [{ value: data }] }) => {
                return data.isagree !== 1 || value;
              }
            ),
          code: yup.string().required("必填"),
        })
        .required()
    );
  }, []);

  useEffect(() => {
    let formType = localStorage.getItem("formType");
    if (redux_form.formType === "" && formType === "")
      route_navigate("/chooseForm");
  }, [redux_form]);

  const onSubmit = (submitData) => {
    if (captchaSetting.code !== submitData.code) {
      dispatch(
        setToast({
          severity: "warn",
          summary: submitData.code === null ? "請填寫驗證碼" : "驗證碼錯誤",
          detail: "",
        })
      );
      setValue("code", null);
      return;
    }

    let { birthday, tyear } = submitData,
      nowYear = moment().format("YYYY");
    birthday = moment(birthday).format("YYYY");
    if (Number(birthday) + Number(tyear) > Number(nowYear)) {
      dispatch(
        setToast({
          severity: "warn",
          summary: "治療時間與小孩出生年不符合",
          detail: "",
        })
      );
      return;
    }

    dispatch(setProgress(true));

    let jsonData = {
      ...submitData,
    };

    MainAPI.setMainInfo({
      data: jsonData,
    }).then((result) => {
      let { Response, data, message } = result;

      if (Response === 1) {
        dispatch(setFormStep(0));
        dispatch(setFormUser(data));
        route_navigate("/stepForm");
        dispatch(
          setToast({
            severity: "success",
            summary: `送出成功`,
            detail: "",
          })
        );
      } else {
        dispatch(
          setToast({
            severity: "error",
            summary: `送出失敗`,
            detail: message ?? "",
          })
        );
      }
      dispatch(setProgress(false));
    });
  };

  const renderIcon = ({ isImg = false, isRequired = true, icon }) => (
    <div className="relative flex flex-shrink-0 align-items-center justify-content-center w-2rem md:w-3rem border-right-1 border-500">
      {isRequired && (
        <span className="absolute top-50 bottom-50 text-red-400 -mt-3 -ml-4">
          *
        </span>
      )}
      {isImg ? (
        <img style={{ width: "1.3rem" }} src={icon} alt="icon" />
      ) : (
        <i className={classNames(icon)}></i>
      )}
    </div>
  );

  return (
    <>
      <div className="flex flex-column h-full">
        <ModuleSubHead lineType="one" />

        <div className="border-1 border-400 border-round-md p-3 md:p-4 my-5 mx-0 md:mx-4">
          <div className="text-xl text-main font-bold mb-3">
            請您必須完成填寫下列資料，確認送出後才能進入閱覽後續網頁
          </div>

          <div className="text-xl mb-2">
            當您點選確認按鈕後，後面各項資料將寄送到您的 E-mail
            中，屆時您可以列印及攜帶此份結果與您的小孩之主治醫師討論。
          </div>

          <form onSubmit={handleSubmit(onSubmit)} className="formgrid">
            <div className="flex border-1 border-500 my-2">
              {renderIcon({ isImg: true, icon: ImgEnvelope })}
              <div className="flex align-items-center flex-auto px-1 sm:px-2 py-1">
                <div
                  className={classNames("white-space-nowrap mr-3", {
                    "p-error": errors.email,
                  })}
                >
                  家長主要信箱
                </div>
                <FormInputtext
                  className="w-full md:w-20rem"
                  setting={setting}
                  data={{
                    name: "email",
                  }}
                />
              </div>
            </div>

            <div className="flex border-1 border-500 my-2">
              {renderIcon({ isImg: true, icon: ImgGender })}
              <div className="flex align-items-start flex-auto px-1 sm:px-2 py-1">
                <div
                  className={classNames("white-space-nowrap mr-3 mt-2", {
                    "p-error": errors.psex,
                  })}
                >
                  身分
                </div>
                <div className="flex flex-wrap">
                  {option_parent.map((item) => (
                    <FormRadio
                      key={`parent_${item.value}`}
                      setting={setting}
                      data={{
                        name: "psex",
                        label: item.label,
                        value: item.value,
                      }}
                    />
                  ))}
                </div>
              </div>
            </div>

            <div className="flex border-1 border-500 my-2">
              {renderIcon({ isImg: true, icon: ImgHat })}
              <div className="flex align-items-start flex-auto px-1 sm:px-2 py-1">
                <div
                  className={classNames("white-space-nowrap mr-3 mt-2", {
                    "p-error": errors.edlevel,
                  })}
                >
                  家長教育程度
                </div>
                <div className="flex flex-wrap">
                  {option_education.map((item) => (
                    <FormRadio
                      key={`education_${item.value}`}
                      setting={setting}
                      data={{
                        name: "edlevel",
                        label: item.label,
                        value: item.value,
                      }}
                    />
                  ))}
                </div>
              </div>
            </div>

            <div className="flex border-1 border-500 my-2">
              {renderIcon({ icon: "fa fa-user" })}
              <div className="flex align-items-start flex-auto px-1 sm:px-2 py-1">
                <div
                  className={classNames("white-space-nowrap mr-3 mt-2", {
                    "p-error": errors.ksex,
                  })}
                >
                  小孩性別
                </div>
                <div className="flex flex-wrap">
                  {option_sex.map((item) => (
                    <FormRadio
                      key={`parent_${item.value}`}
                      setting={setting}
                      data={{
                        name: "ksex",
                        label: item.label,
                        value: item.value,
                      }}
                    />
                  ))}
                </div>
              </div>
            </div>

            <div className="flex border-1 border-500 my-2">
              {renderIcon({ isImg: true, icon: ImgBirthday })}
              <div className="flex align-items-center flex-auto px-1 sm:px-2 py-1">
                <span
                  className={classNames("white-space-nowrap mr-3", {
                    "p-error": errors.birthday,
                  })}
                >
                  小孩出生年(西元)
                </span>
                <FormCalendar
                  className="w-full md:w-15rem"
                  setting={setting}
                  data={{
                    name: "birthday",
                    view: "year",
                    dateFormat: "yy",
                    maxDate: new Date(),
                  }}
                />
              </div>
            </div>

            <div className="flex border-1 border-500 my-2">
              {renderIcon({ isImg: true, icon: ImgEye })}
              <div className="flex flex-column lg:flex-row lg:align-items-center flex-auto px-1 sm:px-2 py-1">
                <div className="flex flex-column sm:flex-row sm:align-items-center w-full sm:w-6 mb-2 lg:mb-0">
                  <span
                    className={classNames("white-space-nowrap mr-3", {
                      "p-error": errors.ldegree || errors.rdegree,
                    })}
                  >
                    小孩近視度數(目前)
                  </span>
                  <div className="flex align-items-center flex-auto mt-2 sm:mt-0">
                    <span
                      className={classNames("mr-2", {
                        "p-error": errors.ldegree,
                      })}
                    >
                      左
                    </span>
                    <FormInputnumber
                      className="w-6rem"
                      setting={setting}
                      data={{
                        name: "ldegree",
                        useGrouping: false,
                      }}
                    />
                    <span
                      className={classNames("mx-2", {
                        "p-error": errors.rdegree,
                      })}
                    >
                      右
                    </span>
                    <FormInputnumber
                      className="w-6rem"
                      setting={setting}
                      data={{
                        name: "rdegree",
                        useGrouping: false,
                      }}
                    />
                  </div>
                </div>
                <div className="flex flex-column sm:flex-row sm:align-items-center w-full sm:w-6">
                  <span
                    className={classNames("white-space-nowrap mr-3", {
                      "p-error": errors.lastigmatism || errors.rastigmatism,
                    })}
                  >
                    散光度數(目前)
                  </span>
                  <div className="flex align-items-center flex-auto mt-2 sm:mt-0">
                    <span
                      className={classNames("mr-2", {
                        "p-error": errors.lastigmatism,
                      })}
                    >
                      左
                    </span>
                    <FormInputnumber
                      className="w-6rem"
                      setting={setting}
                      data={{
                        name: "lastigmatism",
                        useGrouping: false,
                      }}
                    />
                    <span
                      className={classNames("mx-2", {
                        "p-error": errors.rastigmatism,
                      })}
                    >
                      右
                    </span>
                    <FormInputnumber
                      className="w-6rem"
                      setting={setting}
                      data={{
                        name: "rastigmatism",
                        useGrouping: false,
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="flex border-1 border-500 my-2">
              {renderIcon({ isImg: true, icon: ImgClock })}
              <div className="flex flex-column sm:flex-row sm:align-items-center flex-auto px-1 sm:px-2 py-1">
                <span
                  className={classNames("white-space-nowrap mr-3", {
                    "p-error":
                      errors.tyear || errors.tmonth || errors.treatment,
                  })}
                >
                  治療時間
                </span>
                <div className="flex flex-column sm:flex-row sm:align-items-center flex-auto mt-2 sm:mt-0">
                  <div className="flex align-items-center">
                    <FormInputnumber
                      className="flex-shrink-0 w-6rem"
                      setting={setting}
                      data={{
                        name: "tyear",
                        useGrouping: false,
                      }}
                    />
                    <span
                      className={classNames("mx-2", {
                        "p-error": errors.tyear,
                      })}
                    >
                      年
                    </span>
                    <FormInputnumber
                      className="flex-shrink-0 w-6rem"
                      setting={setting}
                      data={{
                        name: "tmonth",
                        useGrouping: false,
                      }}
                    />
                    <span
                      className={classNames("ml-2", {
                        "p-error": errors.tmonth,
                      })}
                    >
                      月
                    </span>
                    <span className="hidden sm:inline-block">，</span>
                  </div>
                  <div className="flex align-items-center mt-2 sm:mt-0">
                    <span
                      className={classNames("white-space-nowrap ml-2", {
                        "p-error": errors.treatment,
                      })}
                    >
                      方式：
                    </span>
                    <FormInputtext
                      className="w-full flex-auto md:max-w-20rem"
                      setting={setting}
                      data={{
                        name: "treatment",
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="flex border-1 border-500 my-2">
              {renderIcon({ isImg: true, icon: ImgGlasses })}
              <div className="flex flex-column md:flex-row md:align-items-center flex-auto px-1 sm:px-2 py-1">
                <span
                  className={classNames("mr-2", {
                    "p-error": errors.laxis || errors.raxis,
                  })}
                >
                  若有檢測眼軸長度
                </span>
                <div className="flex flex-column md:flex-row md:align-items-center flex-auto mt-2 md:mt-0">
                  <div className="flex align-items-center">
                    <FormInputtext
                      className="flex-shrink-0 w-6rem"
                      setting={setting}
                      data={{
                        name: "laxis",
                        useGrouping: false,
                      }}
                    />
                    <span
                      className={classNames("mx-2", {
                        "p-error": errors.laxis,
                      })}
                    >
                      mm(左眼)
                    </span>
                    <FormInputtext
                      className="flex-shrink-0 w-6rem"
                      setting={setting}
                      data={{
                        name: "raxis",
                        useGrouping: false,
                      }}
                    />
                    <span
                      className={classNames("ml-2", {
                        "p-error": errors.raxis,
                      })}
                    >
                      mm(右眼)
                    </span>
                  </div>
                  <div className="md:ml-3 mt-2 md:mt-0">
                    (不知道者請填不知道)
                  </div>
                </div>
              </div>
            </div>

            <div className="flex border-1 border-500 my-2">
              {renderIcon({ isImg: true, icon: ImgPen })}
              <div className="flex align-items-start flex-auto px-1 sm:px-2 py-1">
                <span
                  className={classNames("mr-2 mt-2", {
                    "p-error": errors.isagree,
                  })}
                >
                  是否接受後續問卷調查，每次調查審核完畢寄送100元禮券
                </span>
                <div className="flex flex-wrap">
                  {option_want.map((item) => (
                    <FormRadio
                      key={`parent_${item.value}`}
                      setting={setting}
                      data={{
                        name: "isagree",
                        label: item.label,
                        value: item.value,
                      }}
                    />
                  ))}
                </div>
              </div>
            </div>

            <div className="flex border-1 border-500 my-2">
              {renderIcon({
                icon: "fa fa-globe",
                isRequired: getValues("isagree") === 1,
              })}
              <div className="flex align-items-center flex-auto px-1 sm:px-2 py-1">
                <span
                  className={classNames("white-space-nowrap mr-3", {
                    "p-error": errors.address,
                  })}
                >
                  郵寄地址
                </span>
                <FormInputtext
                  className="w-full md:w-30rem"
                  setting={setting}
                  data={{
                    name: "address",
                  }}
                />
              </div>
            </div>

            <div className="flex border-1 border-500 my-2">
              {renderIcon({ isImg: true, icon: ImgCode })}
              <div className="flex flex-column sm:flex-row sm:align-items-center flex-auto px-1 sm:px-2 py-1">
                <div className="flex align-items-center mb-2 sm:mb-0">
                  <span
                    className={classNames("white-space-nowrap mr-3", {
                      "p-error": errors.code,
                    })}
                  >
                    驗證碼
                  </span>
                  <FormInputtext
                    className="w-8rem mr-3"
                    setting={setting}
                    data={{
                      name: "code",
                      useGrouping: false,
                    }}
                  />
                </div>
                {renderCaptcha()}
              </div>
            </div>

            <div className="col-12 text-center">
              <Button
                type="button"
                label="返回"
                className="p-button-secondary px-3"
                onClick={() => {
                  dispatch(setFormType(""));
                  route_navigate("/chooseForm");
                }}
              />
              <Button
                type="submit"
                label="確認送出"
                icon="fa fa-check-square-o"
                className="p-button-warning text-white ml-3 px-3"
              />
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
